import Color from 'color';
export const getColorObject = ({ color, defaultColor, }) => {
    const finalColor = color &&
        typeof color === 'string' &&
        !(color.includes('#') || color.includes('rgb'))
        ? `#${color}`
        : color;
    try {
        return Color(finalColor);
    }
    catch (_a) {
        return Color(defaultColor);
    }
};
export const getCSSGradient = ({ gradient, }) => {
    if (gradient.type === 'radial') {
        return `radial-gradient(circle, ${gradient.color1} ${gradient.color1Percentage}%, ${gradient.color2} ${gradient.color2Percentage}%)`;
    }
    return `linear-gradient(${gradient.angle}deg, ${gradient.color1} ${gradient.color1Percentage}%, ${gradient.color2} ${gradient.color2Percentage}%)`;
};
export const getInputColor = ({ color, defaultColor, }) => getColorObject({ color: color || defaultColor })
    .hex()
    .replace('#', '');
//# sourceMappingURL=utils.js.map